import React, { memo, useEffect, useRef, useState } from "react";
import "../CSS/introduction.css";
import "../App.css";
import home from "../Images/navbar/homeicon.png";
import downloadResume from "../Images/downloadresume.png";
import download from "../Images/download.png";

function Introduction({ setindex }) {
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(0);
        }
      });
    }, options);

    const divs = document.getElementById("introduction");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);

  useEffect(() => {
    const specialtyText = document.getElementById("specialty");
    const specialties = ["Web Development", "AI/ML", "Data Science"];
    let currentSpecialtyIndex = 0;
    let currentCharacterIndex = 0;
    let isDeleting = false;
    let timeout;

    function type() {
      const currentSpecialty = specialties[currentSpecialtyIndex];
      if (isDeleting) {
        specialtyText.textContent = currentSpecialty.substring(
          0,
          currentCharacterIndex
        );
        currentCharacterIndex--;
      } else {
        specialtyText.textContent = currentSpecialty.substring(
          0,
          currentCharacterIndex + 1
        );
        currentCharacterIndex++;
      }

      if (!isDeleting && currentCharacterIndex === currentSpecialty.length) {
        isDeleting = true;
        timeout = setTimeout(type, 1000);
      } else if (isDeleting && currentCharacterIndex === 0) {
        isDeleting = false;
        currentSpecialtyIndex =
          (currentSpecialtyIndex + 1) % specialties.length;
        timeout = setTimeout(type, 500);
      } else {
        timeout = setTimeout(type, isDeleting ? 50 : 150);
      }
    }

    type();

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <div id="introduction" className="introduction">
        <br />
        <div className="header-block fontbold">
          <img src={home} alt="intro" />
          Introduction
        </div>
        <br />
        <br />
        <div>
          <div className="introtextanimation">
            <span>
              Hi, I am <span className="namecolor">Dev!</span>I specialize in{" "}
            </span>
            <span className="specialty" id="specialty">
              Web development
            </span>
          </div>
          <br />
          <div className="introabout">
            I am a passionate and enthusiastic developer, with experience in{" "}
            <span className="namecolor">
              React, Node.js, Express, MongoDB, and Python
            </span>{" "}
            .I specialize in creating intuitive web applications using MERN
            stack as well as implementing Machine learning Models using python.
          </div>
          <br />
          <br />
          <br />
          <div className="resumecontainer">
            <div className="emptyspace"></div>
            <a href="https://github.com/Dev2907/Resume/blob/main/resume.pdf">
              <div className="imagewrapper">
                <img
                  src={downloadResume}
                  alt="download"
                  className="downloadcircle"
                ></img>
                <img
                  src={download}
                  alt="download"
                  className="downloadimage"
                ></img>
              </div>
            </a>
          </div>
          <br />
          <br />
          <br />
          <div className="introproject">
            Personal Projects : <span className="namecolor">14+</span>
          </div>
        </div>
      </div>
    </>
  );
}
export default Introduction;
